import { createSelector } from 'reselect';
import { Tier } from '../entities';
export const selectUserTier = createSelector([(store) => store.user.user], (user) => {
    if (user.emmaProStatus?.active && user.emmaProStatus?.tier) {
        return user.emmaProStatus.tier;
    }
    return Tier.free;
});
export const selectIsUserUltimate = createSelector([(store) => store.user.user], (user) => {
    if (user.emmaProStatus.active && user.emmaProStatus.tier) {
        return user.emmaProStatus.tier === Tier.ultimate;
    }
    return false;
});
export const selectIsUserFreeTier = createSelector(selectUserTier, (tier) => tier === Tier.free);
export const selectIsUserOnPremium = createSelector([(store) => store.user.user], (user) => {
    if (user.emmaProStatus?.active &&
        user.emmaProStatus?.tier &&
        user.emmaProStatus?.tier !== Tier.free &&
        !user.emmaProStatus?.isOnFreeTrial &&
        !user.emmaProStatus?.reverseTrial?.active) {
        return true;
    }
    return false;
});
export const selectIsUserOnAnnual = createSelector([(store) => store.user.user, selectIsUserOnPremium], (user, isOnPremium) => {
    if (isOnPremium && user.emmaProStatus?.period) {
        return user.emmaProStatus.period === 'yearly';
    }
    return false;
});
export const selectUserCurrentPrice = createSelector([(store) => store.user.user, selectIsUserOnPremium], (user, isOnPremium) => {
    if (isOnPremium && user.emmaProStatus?.currentPrice) {
        return user.emmaProStatus?.currentPrice;
    }
    return null;
});
export const selectUserIsRefundable = createSelector([(store) => store.user.user, selectIsUserOnPremium], (user, isOnPremium) => {
    if (isOnPremium && user.emmaProStatus?.refundableAmount) {
        return user.emmaProStatus?.refundableAmount;
    }
    return null;
});
export const selectUserOrganisation = createSelector([(store) => store.user.user, selectIsUserOnPremium], (user, isOnPremium) => {
    if (isOnPremium &&
        user.emmaProStatus &&
        'type' in user.emmaProStatus &&
        user.emmaProStatus.type === 'employee' &&
        'employerInfo' in user.emmaProStatus) {
        return user.emmaProStatus.employerInfo;
    }
    return null;
});
